import { useAuth } from '../contexts/AuthContext';

export const usePermissions = () => {
  const { hasPermission, hasRole } = useAuth();

  // Helper function to check permissions for a specific module
  const modulePermissions = (module) => {
    // Special handling for product_groups and companies - developers get default access
    if (module === 'product_groups' || module === 'companies') {
      const isDeveloper = hasRole('developer');
      if (isDeveloper) {
        console.log(`🔓 Developer detected - granting default ${module} access`);
        return {
          canView: true,
          canCreate: true,
          canUpdate: true,
          canDelete: true,
        };
      }
    }

    // Standard permission check for all other modules and non-developers
    return {
      canView: hasPermission(`${module}_view`),
      canCreate: hasPermission(`${module}_create`),
      canUpdate: hasPermission(`${module}_update`),
      canDelete: hasPermission(`${module}_delete`),
    };
  };

  // Specific module permission checks
  const employees = modulePermissions('employees');
  const products = modulePermissions('products');
  const categories = modulePermissions('categories');
  const companies = modulePermissions('companies');
  const productGroups = modulePermissions('product_groups');
  const orders = modulePermissions('orders');
  const customers = modulePermissions('customers');
  const subscriptions = modulePermissions('subscriptions');
  const notifications = modulePermissions('notifications');
  const settings = modulePermissions('settings');
  const permissions = modulePermissions('permissions');

  return {
    hasPermission,
    modulePermissions,
    employees,
    products,
    categories,
    companies,
    productGroups,
    orders,
    customers,
    subscriptions,
    notifications,
    settings,
    permissions,
  };
};